import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IFeatureListStyles {
  root?: IStyle;
  featureList?: IStyle;
  emptyFeatureList?: IStyle;
}

export interface IFeatureListClassNames {
  root: string;
  featureList?: string;
  emptyFeatureList?: string;
}

export const featureListStylesDefault = (_theme: IH2OTheme): Partial<IFeatureListStyles> => ({
  root: {
    minHeight: 0,
    flex: 1,
  },
  featureList: {
    height: '100%',
    overflow: 'auto',
  },
});
